import React, { Component } from 'react'
import { productsService } from '../../_services/products.service'
import { Dropdown } from 'semantic-ui-react'
import ExtendedMultiSelect from './ExtendedMultiSelect'


class AsyncProductsMultiSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: this.props.defaultValue || undefined,
      brandId: this.props.brandId,
      categoryId: this.props.categoryId,
      data: [],
      selected: [],
    };
  }

  componentWillMount() {
    this.getData();
  }

  getData() {

    if (this.state.categoryId && this.state.brandId) {
      this.setState({ loading: true })
      productsService.getAllByCategoryAndBrand(this.state.categoryId, this.state.brandId)
        .then((res) => {
          // console.log(res.data);

          let data = res.data.map(elm => ({ "label": elm.name, "value": elm.id }))
          this.setState({ data: data, loading: false, isSubmitting: false });
        }).catch((error) => {
          this.setState({ loading: false })
          // console.log(error)
        });
    }


  };


  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue });
    }
    if (nextProps.categoryId !== this.state.categoryId) {
      this.setState({ categoryId: nextProps.categoryId, data: [] }, () => {
        this.getData();
      });
    }
    if (nextProps.brandId !== this.state.brandId) {
      this.setState({ brandId: nextProps.brandId, data: [] }, () => {
        this.getData();
      });
    }
  }

 

  handleChange = vals => {
    var selected = [].slice
      .call(vals)
      .map(option => option.value)
    // var labels = [].slice
    //   .call(vals)
    //   .map(option => option.label)

    this.setState({ "selected": selected })
    this.props.onChange(selected);
  }

  handleSearchChange = e => {

    // const {categoryId, brandId} = this.state;




  }

  render() {

    const { data, loading, defaultValue, disabled, selected } = this.state;
    const { clearable, className, required } = this.props;

    return (
      <ExtendedMultiSelect
        allowSelectAll={true}
        placeholder=""
        // styles={customStyles}
        value={data.filter(o => selected.includes(o.value))}
        //  error={errors.selected}
        //  touched={touched.selected}
        //  onChange={evt =>
        //    {console.log(evt);
        //    this.setState({
        //      "selected":
        //      [].slice
        //        .call(evt)
        //        .map(option => option.value)
        //    })
        // }}
        onChange={val => this.handleChange(val)}
        isMulti
        options={data}
        className={required ? "select required" : "select"}
        noOptionsMessage={() => "نتیجه ای یافت نشد"}
        loadingMessage={() => "در حال دریافت اطلاعات از سرور"}
        isLoading={loading}
      />
      // <Dropdown
      //   placeholder=''
      //   fluid
      //   search
      //   selection
      //   basic
      //   onChange={(e, d) => this.handleChange(d.value)}
      //   value={defaultValue}
      //   onSearchChange={(e, d) => this.handleSearchChange(e.target.value)}
      //   className={className}
      //   options={data}
      //   wrapSelection={false}
      //   selectOnBlur={false}
      //   searchInput={{ autoFocus: false }}
      //   loading={loading}
      //   disabled={disabled}
      //   clearable={clearable}
      //   noResultsMessage="رکوردی یافت نشد"
      //   direction="right"
      // />
    );
  }
}
export default AsyncProductsMultiSelect;
